/* eslint-disable import/prefer-default-export */

export const DATA_TABLE_EL_CHANGED = 'DATA_TABLE_EL_CHANGED';
export const FOLLOW_UP_EXISTS_CHANGED = 'FOLLOW_UP_EXISTS_CHANGED';
export const FOLLOW_UP_MANAGER_FOLLOW_UP_CHANGED = 'FOLLOW_UP_MANAGER_FOLLOW_UP_CHANGED';
export const PIPELINE_CHANGED = 'PIPELINE_CHANGED';
export const NEW_OUTREACH_CHANGED = 'NEW_OUTREACH_CHANGED';
